export * from './useScopeDetail2';
